import { createContext } from 'react'

import { NotificationConfig } from '~/shared/types/notifications.ts'

interface NotificationContextData {
  notification: NotificationConfig | null,
  setNotification: (message: NotificationConfig | null) => void,
}

export const NotificationContext = createContext<NotificationContextData>({
  notification: null,
  setNotification: () => {},
})